var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.396 1.042c.66 1.324 1.415 2.743 2.264 3.974.566.946.566 1.23.19 2.08-.379.853-1.888 1.799-2.548 2.556.094 1.609 5.377 6.907 6.98 7.002.755-.662 1.699-2.081 2.548-2.46.85-.38 1.226-.473 2.075.094 1.226.852 2.642 1.609 3.962 2.366.566.284.85.852 1.039 1.419l.094.095v.19c0 3.69-4.057 6.055-7.358 5.582C9.285 22.994.982 14.667.04 7.288-.338 3.976 2.02-.092 5.7.002h.284c.566.19 1.132.567 1.415 1.04h-.003zm-1.862-.04C2.575.906.666 4.357 1.049 7.136c.859 6.997 8.97 14.952 15.843 15.815 2.673.384 6.108-1.533 6.108-4.504-.191-.575-.477-.767-.477-.767s-3.53-1.917-4.2-2.396c-.572-.384-.572-.192-.954 0-.383.096-2.004 2.204-2.482 2.492-1.91 1.15-9.83-6.805-8.685-8.722.287-.384 2.386-2.108 2.577-2.396.096-.384.287-.384-.095-1.055C8.3 4.932 6.298 1.48 6.298 1.48s-.096-.288-.764-.479z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPhone);
export default __webpack_public_path__ + "static/media/ico_phone.9c1c71474a30f7e454071d6fdca3c71e.svg";
export { ForwardRef as ReactComponent };